import { Module } from "vuex";

import type { State } from "@/core/store/globalStore";

interface SidebarItem {
	content: Element | null;
	isActive: boolean;
}

interface ContainerWithSliderState {
	sidebars: Record<string, SidebarItem>;
}
const initialState: ContainerWithSliderState = {
	sidebars: {},
};

export const containerWithSliderModule: Module<ContainerWithSliderState, State> = {
	state: () => initialState,

	mutations: {
		addSidebar(state, { id }: { id: string }) {
			state.sidebars[id] = {
				isActive: false,
				content: null,
			};
		},
		updateSidebar(state, { id, content, isActive }: { id: string; content?: Element; isActive?: boolean }) {
			if (id in state.sidebars) {
				if (content !== undefined) state.sidebars[id].content = content;
				if (isActive !== undefined) state.sidebars[id].isActive = isActive;
			}
		},
		updateActive(state, { id, value }: { id: string; value: boolean }) {
			state.sidebars[id].isActive = value;
		},
		removeSidebar(state, id: string) {
			delete state.sidebars[id];
		},
	},

	getters: {
		getSidebarContent: (state) => (id: string) => state.sidebars[id]?.content,
		getSidebarIsActive: (state) => (id: string) => state.sidebars[id]?.isActive,
		getSidebar: (state) => (id: string) => state.sidebars[id],
	},

	actions: {
		addSidebar({ commit }, id: string) {
			commit("addSidebar", { id });
		},
		updateActive({ commit }, { id, value }: { id: string; value: boolean }) {
			commit("updateActive", { id, value });
		},
		updateSidebar({ commit }, payload: { id: string; content?: Element; isActive?: boolean }) {
			commit("updateSidebar", payload);
		},
		removeSidebar({ commit }, id: string) {
			commit("removeSidebar", id);
		},
	},

	namespaced: true,
};
